import { render } from "./DataQualityScorecardTable.vue?vue&type=template&id=591b9439&scoped=true"
import script from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"
export * from "./DataQualityScorecardTable.vue?vue&type=script&lang=js"

import "./DataQualityScorecardTable.vue?vue&type=style&index=0&id=591b9439&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-591b9439"]])

export default __exports__